<template>
  <!-- <el-dialog :visible.sync="visible" :title="$t('oss.upload')" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false"> -->
    <el-upload
      ref="upload"
      action="no"
      :file-list="fileList"
      :multiple="multiple"
      :http-request="uploadOk"
      :on-success="successHandle"
      :auto-upload="true"
      :on-change="handleExceed"
      >
      <el-button :size="btnSize" type="primary">导入</el-button>
    </el-upload>

</template>

<script>
import Cookies from 'js-cookie'
export default {
  props: {
    multiple: {
      type: Boolean,
      default: true,
      required: false
    },
    uploadType: {
      type: Array,
      default: function () {
        return ['file/xlsx', 'file/xls']
      },
      required: false
    },
    objId: {
      type: [String, Number],
      default: '1111',
      required: false
    },
    objType: {
      type: String,
      default: '222',
      required: false
    },
    uploadUrl: {
      type: String,
      default: '',
      required: false
    },
    params: {
      type: String,
      default: '',
      required: false
    },
    btnSize: ''
  },
  data () {
    return {
      visible: false,
      num: 0,
      datas: [],
      fileList: []
    }
  },
  methods: {
    init () {
      this.visible = true
      this.url = `${window.SITE_CONFIG['apiURL']}/depot/or/ordererpimportdetail/importFile?token=${Cookies.get('token')}`
      this.num = 0
      this.fileList = []
    },
    // 上传之前
    // beforeUploadHandle (file) {
    //   if (this.uploadType && this.uploadType.length > 0) {
    //     if (this.uploadType.indexOf(file.type) === -1) {
    //       this.$message.error(this.$t('upload.tip', { 'format': 'xlsx、xls' }))
    //       return false
    //     }
    //   }
    //   this.num++
    // },
    handleExceed (files, fileList) {
      this.$refs.upload.clearFiles()
    },
    // 上传操作
    uploadOk (val) {
      let fd = new FormData()
      fd.append('objId', this.objId)
      fd.append('objType', this.objType)
      fd.append('file', val.file)
      this.$http.post(this.uploadUrl, fd).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.successHandle(res.data)
        // console.log(res.data)
      }).catch(() => {})
    },
    // 上传成功
    successHandle (data) {
      this.datas.push(data)
      if (this.num === 0) {
        this.disabledStr = false
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.visible = false
            this.$emit('backSuccess', this.datas)
          }
        })
      }
      // this.$emit('backSuccess', this.datas)
    }
  }
}
</script>
<style lang="scss">
.el-button--primary {
    color: #FFF;
    background-color: #409EFF;
    border-color:#409EFF;
}
 .el-button--medium {
   padding: 12px 20px !important;
 }
</style>
